import {Stack, styled, Typography} from '@mui/material';
import {StyledDotProps, StyledItemContainerProps} from './types';

const StyledItemContainer = styled(Stack)<StyledItemContainerProps>`
	width: 100%;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding-top: 16px;
	gap: 8px;
	border-top: ${({$first, theme}) =>
		$first ? null : `1px solid ${theme.colors.gray.A10Percent}`};
`;

const StyledButtonContainer = styled(Stack)`
	flex-direction: row;
	align-items: center;
	gap: 8px;
`;

const StyledStatusContainer = styled(Stack)`
	flex-direction: row;
	align-items: center;
	gap: 4px;
	padding-top: 2px;
`;

const StyledStatusTypography = styled(Typography)`
	font-size: 12px;
	color: ${({theme}) => theme.palette.text.secondary};
`;

const StyledDot = styled(Stack)<StyledDotProps>`
	min-width: 8px;
	min-height: 8px;
	width: 8px;
	height: 8px;
	border-radius: 20px;
	background-color: ${({$isReleased, theme}) =>
		$isReleased ? theme.palette.success.light : theme.palette.warning.main};
`;

export {
	StyledItemContainer,
	StyledButtonContainer,
	StyledStatusTypography,
	StyledStatusContainer,
	StyledDot,
};
